import {PluginListenerHandle, registerPlugin} from "@capacitor/core";

interface Plugin {
    getIsDisplaySetup(): Promise<{isSetup: boolean}>;
    setContent(option: {value: string}): Promise<void>;
    /**
     * Listens for screen orientation changes.
     */
    addListener(
        eventName: "secondaryDisplayStatusChange",
        listenerFunc: (data: {isConnected: boolean}) => void,
    ): Promise<PluginListenerHandle>;

    /**
     * Removes all listeners
     */
    removeAllListeners(): Promise<void>;
}
const SecondaryDisplayPlugin = registerPlugin<Plugin>("SecondaryDisplay");

export default SecondaryDisplayPlugin;
